import {Injectable} from '@angular/core';
import {LocalStorageService} from '@emma-labs/shared/angular';

const AGENT_SESSION_KEY = 'agent_session_key';

@Injectable({
  providedIn: 'root',
})
export class LocalKeyStorage {
  constructor(private localStorageService: LocalStorageService) {}

  getAgentSessionId(): string | null {
    return this.localStorageService.getItem(AGENT_SESSION_KEY) ?? null;
  }

  setAgentSessionId(sessionId: string) {
    this.localStorageService.setItem(AGENT_SESSION_KEY, sessionId);
  }

  removeAgentSessionId() {
    this.localStorageService.removeItem(AGENT_SESSION_KEY);
  }
}
